var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 429,
    height: 433,
    viewBox: "0 0 429 433",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_71)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 429,
    height: 433,
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 24C106 24 20 110 20 216C20 322 106 408 212 408C318 408 404 322 404 216C404 110 318 24 212 24Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 176L212 272L116 176",
    stroke: "white",
    strokeWidth: 32,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_71"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 429,
    height: 433,
    fill: "transparent"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterChevronDown);
export default __webpack_public_path__ + "static/media/filter-chevron-down.c99d8a834481bb5a7bffba8707ac684e.svg";
export { ForwardRef as ReactComponent };